/* eslint-disable func-names, max-len, no-new, no-underscore-dangle */
$(() => {
  const $uploadText = $('.js-image-upload-text');
  const $uploader = $('.js-image-upload');

  if ($uploader.length === 0 || $uploadText.length === 0) {
    return;
  }

  $('.js-image-upload-text').click(() => {
    $('.js-image-upload').click();
  });

  $('.js-image-upload').change(() => {
    $('.js-image-upload-text').val($('.js-image-upload').val());
  });
});

$(window).load(() => {
  setTimeout(() => {
    const $prePopulatedForm = $('.js-pre-populated');
    if ($prePopulatedForm.length) {
      $('html, body').animate({
        scrollTop: $prePopulatedForm.offset().top,
      }, 1000);
    }
  }, 1000);
});
